import React, { useEffect, useState } from 'react';
import useThemeStore from '$/store/useThemeStore';
import classNames from 'classnames';
import { useSessionStorageState } from 'ahooks';
import NextImage from '$/components/NextImage';
import { useOfficialStore } from '$/store/useOfficialStore';
import { openVipModal } from '$/store/useVipModalStore';
import { mtstatTrack } from '$/utils/mtstat';
import { getSourceByPath } from '$/utils/getSourceByPath';
import Button from '../base/Button';
import styles from './index.module.scss';
import { useNoticeFloatCardConfig } from './useNoticeFloatCardConfig';
import useCardType, { CardType } from './useCardType';

const needShowCardList = [CardType.SORA, CardType.NANO_BANANA];

interface NoticeFloatCardProps {
  from: 'canvas' | 'workflow';
  style?: React.CSSProperties;
}

export default function NoticeFloatCard({
  from,
  style,
}: NoticeFloatCardProps) {
  const cardType = useCardType(from);
  const config = useNoticeFloatCardConfig(cardType);
  const userInfo = useOfficialStore((state) => state.userInfo);

  const [show, setShow] = useState(false);
  const theme = useThemeStore((state) => state.theme);

  const getTrackVipValue = () => {
    if (!userInfo?.subscribe?.isValid) {
      return 1;
    }
    return userInfo?.subscribe?.level + 1;
  };

  const reportData = (event: string) => {
    mtstatTrack(event, {
      from_source: '2',
      membership_type: getTrackVipValue(),
      position_type: getSourceByPath(from === 'canvas' ? 'studio' : 'ai_flow'),
    });
  };

  // 用户是普通会员或者高级会员：点击“Got it”按钮，关闭通知弹窗
  // 用户是基础会员或者不是会员：点击“Got it”按钮，关闭通知弹窗，弹出订阅弹窗
  const onClose = () => {
    reportData('revenue_operation_click');

    setShow(false);
    const isNormalOrAdvanced = userInfo?.subscribe?.level === 2 || userInfo?.subscribe?.level === 3;
    if (!isNormalOrAdvanced) {
      openVipModal('rightside_win');
    }
  };

  useEffect(() => {
    const shouldShow = !!cardType && needShowCardList.includes(cardType);
    if (shouldShow) {
      reportData('revenue_operation_exp');
    }
    setShow(shouldShow);
  }, [cardType]);

  if (!show) return null;

  return (
    <div
      className={classNames(styles.notice_float_card_container, {
        [styles.dark]: theme === 'dark',
        [styles.light]: theme === 'light',
        [styles.in_room]: true,
      })}
      style={style}
    >
      <div className={styles.main_box}>
        <div className={styles.left_box}>
          <NextImage src={config.icon} alt={config.title} className={styles.nano_banana_logo} />
        </div>
        <div className={styles.right_box}>
          <div className={styles.title}>
            {config.title}
          </div>
        </div>
      </div>
      <div className={styles.sub_title}>
        {config.content}
      </div>
      <Button type="default" size="small" className={styles.close_btn} onClick={onClose}>
        {config.closeButtonText}
      </Button>
    </div>
  );
}
